import React from "react";
import { Link } from "react-router-dom";
import { pathMaker } from "../../../../utils/helperFunctions";
import articlePic from "../../../../assets/images/article.png";
import { FiChevronsLeft } from "react-icons/fi";
import "./Product.scss";

const Article = ({ item, more, searchQuery, type, close, active }) => {
    return (
        <div className="product-result">
            {more ? (
                <Link
                    to={`/${type === "product" ? "category" : "blog"
                        }/search?keyword=${searchQuery}&page=1`}
                    className="category-result-link"
                    onClick={(e) => {
                        active(false);
                        close();
                    }}
                >
                    <span className="category-result-link-text">مشاهده بیشتر</span>
                    <span className="category-result-link-icon">
                        <FiChevronsLeft />
                    </span>
                </Link>
            ) : (
                <Link
                    to={`/blog/post/${item.id}?page=1/`}
                    style={{ textDecoration: "none", color: "inherit" }}
                    onClick={(e) => active(false)}
                >
                    <div className="product-result-photo">
                        <img
                            src={
                                item.file.length !== 0
                                    ? pathMaker(item.file[0].url)
                                    : articlePic
                            }
                            alt={item.title}
                        />
                    </div>
                    <div
                        to={`/blog/post/${item.id}?page=1/`}
                        className="product-result-title"
                    >
                        {item.title}
                    </div>
                </Link>
            )}
        </div>
    );
};

export default Article;
